var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { PaperPlaneRightIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export function ChatInput(_a) {
    var { onSend, className, disabled } = _a, props = __rest(_a, ["onSend", "className", "disabled"]);
    const inputRef = useRef(null);
    const [message, setMessage] = useState('');
    const handleSubmit = (e) => {
        var _a;
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, e);
        onSend === null || onSend === void 0 ? void 0 : onSend(message);
        setMessage('');
    };
    const isDisabled = disabled || message.trim().length === 0;
    useEffect(() => {
        var _a;
        if (disabled) {
            return;
        }
        // when not disabled refocus on input
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [disabled]);
    return (_jsxs("form", Object.assign({}, props, { onSubmit: handleSubmit, className: cn('flex items-center gap-2', className), children: [_jsx("input", { autoFocus: true, ref: inputRef, type: "text", value: message, disabled: disabled, placeholder: "Type a message...", onChange: (e) => setMessage(e.target.value), onKeyDown: (e) => e.stopPropagation(), style: { border: '1px solid #E5E7EB' }, className: "h-10 flex-1 rounded-lg bg-gray-50 px-3 py-2.5 text-[14px] text-gray-900 placeholder:text-gray-400 focus:border-[#7C3AED] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50" }), _jsx(Button, { size: "icon", type: "submit", disabled: isDisabled, className: cn('size-10 shrink-0 rounded-lg transition-colors', isDisabled
                    ? 'bg-[#7C3AED] text-white opacity-30'
                    : 'bg-[#7C3AED] text-white hover:bg-[#6D28D9]'), children: _jsx(PaperPlaneRightIcon, { weight: "bold", size: 20 }) })] })));
}
